import * as React from 'react';

const rarityToColor = {
    LETTER: 'rgb(255, 255, 255)',
    UNCOMMON: 'rgb(216, 247, 255)',
    RARE: 'rgb(109, 187, 255)',
    EPIC: 'rgb(194, 127, 255)',
    ELUSIVE: 'rgb(246, 255, 0)',
};

const KeyButtSvg = ({rarity, width, height}) => {
    const mainColor = rarityToColor[rarity];
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                '--main-color': mainColor,
                '--edge-color': 'black',
                '--edge-size': 10,
            }}
        >
            <path
                d="M100 12q353 38 700 0l34 694q-384 44-768 0z"
                fill="var(--main-color)"
            />
            <path
                d="M100 12 35 88 9 885l77-179zm700 0 65 76 26 797-77-179z"
                fill="var(--main-color)"
            />
            <path d="M86 706q364 44 728 0l77 179H9z" fill="var(--main-color)"/>
            <path
                d="M100 12q353 38 700 0m-700 0L35 88 9 885l77-179zm700 0 65 76 26 797-77-179z"
                stroke="var(--edge-color)"
                strokeWidth="var(--edge-size)"
                fill="transparent"
                strokeLinejoin="round"
                strokeLinecap="round"
            />
            <path
                stroke="var(--edge-color)"
                strokeWidth="var(--edge-size)"
                d="M9 885h882"
            />
            <path
                d="M86 706q364 44 728 0"
                stroke="var(--edge-color)"
                strokeWidth="var(--edge-size)"
                fill="transparent"
                strokeLinejoin="round"
                strokeLinecap="round"
            />
        </svg>
    );
};
export default KeyButtSvg;
